import { DespatchProduct } from "../../../../../../models/despatch";
import { SearchAttribute } from "../../../../../../models/search.attribute";
import { DespatchProductToSearch } from "../types";

const useFilterProducts = (products: DespatchProduct[], searchAttributes: SearchAttribute[]) => {
  return searchAttributes.reduce((filteredOrders, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredOrders.filter((despatchProduct: DespatchProductToSearch) => {
        if (objectName === "product") {
          return values.some((value) => {
            const nestedObject = despatchProduct?.container?.[objectName] as any;

            return String(nestedObject?.[objectProperty])
              ?.toLowerCase()
              .includes(value.toLowerCase());
          });
        }

        return values.some((value) => {
          const nestedObject = despatchProduct?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredOrders.filter((despatchProduct: DespatchProductToSearch) => {
      return values.some((value) =>
        String(despatchProduct[attribute])?.toLowerCase().includes(value.toLowerCase())
      );
    });
  }, products);
};

export default useFilterProducts;
